module.exports = __webpack_public_path__ + "static/media/5.Mini Air Compressor.175c2ce8.jpg";